module.exports = __webpack_public_path__ + "static/media/bubbles.ee69f99e.png";